import { RootState, useAppDispatch, useAppSelector } from 'common';
import { RecipeHeader } from 'common/src/api/models/recipe-header.models';
import { selectSecretRecipesGridData } from 'common/src/store/recipes';
import { getRecipeHeaderPrivateUsersByCustomer, getRecipeHeaders } from 'common/src/store/recipes/recipes.thunks';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { CfDataGridProps } from '../../../../cf-ui/DataGrid/CfDataGridProps';
import { CfDataGridContainer } from '../../../../cf-ui/DataGridContainer/CfDataGridContainer';
import { StyledViewBox } from '../../../_shared/components/shared-styled-components.styles';
import { secretRecipesTableView } from '../../components/gridTablesView/SecretRecipesTableView';
import { ManageAccessTableHeader } from '../../components/headers/ManageAccessTableHeader';
import { SecretRecipeRowActionsMenu } from '../../components/secretRowAction/secretRecipeRowActionMenu';
import SecretRecipesDialog, { SecretRecipesDialogProps } from '../../dialogs/SecretRecipesDialog';

export default function SecretRecipes(): JSX.Element {
  const { customerId } = useParams<{ customerId: string }>();
  const dispatch = useAppDispatch();

  const [searchParam, setSearchParam] = useState('');
  const [showManageSecretRecipes, setShowManageSecretRecipes] = useState<SecretRecipesDialogProps | undefined>(
    undefined
  );

  const filteredSecretRecipes = useAppSelector((s: RootState) => selectSecretRecipesGridData(s, searchParam));
  const isRecipeHeadersLoading = useAppSelector((s: RootState) => s.recipes.isRecipeHeadersLoading);

  useEffect(() => {
    dispatch(getRecipeHeaders(customerId));
    dispatch(getRecipeHeaderPrivateUsersByCustomer(customerId));
  }, []);

  const handleDialog = () => {
    setShowManageSecretRecipes({
      onClose: () => setShowManageSecretRecipes(undefined),
    });
  };

  const dataGridProps: CfDataGridProps<RecipeHeader> = {
    id: 'SecretRecipesGrid',
    tableView: secretRecipesTableView(),
    selectId: (item: RecipeHeader) => item.RecipeHeaderId,
    displayMode: 'table',
    autoFocus: 'firstNavigableElement',
    noItemsMessage: 'No recipes found',
    data: {
      pages: [
        {
          pageIndex: 0,
          isLoading: isRecipeHeadersLoading,
          items: filteredSecretRecipes,
          pageSize: filteredSecretRecipes.length,
        },
      ],
      totalPageCount: 1,
      totalItemCount: filteredSecretRecipes.length,
      pagingMode: 'none',
    },
  };
  return (
    <StyledViewBox sx={{ pt: 2 }}>
      <CfDataGridContainer
        dataGridProps={dataGridProps}
        sx={{
          '& .css-nsyoup-MuiCardContent-root': {
            padding: 0,
            margin: 0,
          },
        }}
        controlsContainerSx={{ padding: 0, margin: 0 }}
        customControlsContainer={
          <ManageAccessTableHeader
            title='Secret recipes'
            description='Secret recipes help you keep recipe details like ingredients and steps to yourself. Ingredients and steps are only visible to users designated here.'
            searchPlaceholder='Search recipes'
            setSearchParam={setSearchParam}
            handleDialog={handleDialog}
            isSecretRecipes={true}
          />
        }
      />
      <SecretRecipeRowActionsMenu
        setRefreshUser={() => {
          // todo
        }}
      />
      {showManageSecretRecipes && <SecretRecipesDialog {...showManageSecretRecipes} />}
    </StyledViewBox>
  );
}
